import { ClassConstructor } from "#customTypes/composedTypes/classTypes"
import { StudentConstructor } from "#customTypes/composedTypes/studentTypes"
import { UserConstructor } from "#customTypes/composedTypes/userTypes"

class Log {
  static student = (student: StudentConstructor) =>
    `${student.name} (${student.id})`

  static class = (classObj: ClassConstructor) =>
    `${classObj.name} (${classObj.id})`

  static user = (user: UserConstructor) => `${user.name} (${user.id})`
}

export default Log
